//-- Copyright (c) 2021 TMT Insights Group, LLC
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { setCurrentTable } from '@/redux/slices/dataTableSlice';
import { selectCurrentTableKey } from '@/redux/selectors/dataTableSelectors';
import DataTableFilters from '@/components/_common/Filters/DataTableFilters';
import DataTableLayout from '@/components/_common/Layout/DataTableLayout';
import AvailsTitleBar from './AvailsTitleBar';
import FiltersContainer from '@/components/Focus/common/FiltersContainer';

const Avails = () => {
  const dispatch = useAppDispatch();
  const currentTableKey = useAppSelector(selectCurrentTableKey);

  useEffect(() => {
    dispatch(setCurrentTable('focusAvails'));
  }, []);

  return (
    <>
      {currentTableKey === 'focusAvails' && (
        <DataTableLayout tableKey="focusAvails">
          <AvailsTitleBar />
          <FiltersContainer>
            <DataTableFilters />
          </FiltersContainer>
        </DataTableLayout>
      )}
    </>
  );
};

export default Avails;
